import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Container, Row, Col } from 'react-bootstrap';
import './Projects.css';

const Projects = ({ navigateTo }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" });

    const domains = [
        {
            id: 1,
            title: 'Résidentiel',
            icon: '/icons/proj-residentiel.svg',
            items: [
                'Immeubles d\'habitation (multilogements, condominiums)',
                'Maisons unifamiliales et jumelées',
                'Réhabilitation et agrandissements structuraux',
                'Études de faisabilité et conception de fondations'
            ]
        },
        {
            id: 2,
            title: 'Commercial & Institutionnel',
            icon: '/icons/proj-commercial.svg',
            items: [
                'Bureaux et tours de prestige',
                'Centres commerciaux et complexes récréatifs',
                'Établissements scolaires et universitaires',
                'Centres de santé et hôpitaux'
            ]
        },
        {
            id: 3,
            title: 'Industriel',
            icon: '/icons/proj-industriel.svg',
            items: [
                'Usines et bâtiments de production',
                'Entrepôts et centres de distribution',
                'Structures spécialisées (silos, réservoirs)',
                'Renforcement d\'installations existantes'
            ]
        },
        {
            id: 4,
            title: 'Infrastructures Publiques',
            icon: '/icons/proj-infra.svg',
            items: [
                'Ponceaux, branchement au réseau sanitaire de la ville',
                'Parkings multi-étages et stations de transport',
                'Conception et maintien d\'actif patinoire, skatepark',
                'Réhabilitation infrastructure routière'
            ]
        },
        {
            id: 5,
            title: 'Conseil & Expertise',
            icon: '/icons/proj-conseil.svg',
            items: [
                'Études techniques et analyses structurales',
                'Vérifications structurales et diagnostics',
                'Accompagnement BIM et modélisation 3D'
            ]
        }
    ];

    return (
        <section className="projects-section" ref={ref} style={{ paddingTop: '120px' }}>
            <Container>
                {/* Header Section */}
                <motion.div
                    className="projects-header"
                    initial={{ opacity: 0, y: 40 }}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.8 }}
                >
                    <div className="page-eyebrow">
                        <span className="page-eyebrow-line"></span>
                        <span className="page-eyebrow-text">DHR Structures | Notre Portfolio</span>
                        <span className="page-eyebrow-dot"></span>
                    </div>
                    <h1 className="projects-title">
                        Nos Domaines d'Intervention en<br />
                        <span className="highlight-text">Génie Structural</span>
                    </h1>
                    <p className="projects-subtitle">
                        Découvrez les domaines d'expertise de DHR Structures. Notre équipe d'ingénieurs
                        expérimentés maîtrise la conception et la réalisation de projets variés en ingénierie
                        civile et structurale.
                    </p>
                </motion.div>

                {/* Domain Cards */}
                <Row className="justify-content-center mt-4">
                    {domains.map((domain, index) => (
                        <Col lg={index < 2 ? 6 : 4} md={6} sm={12} key={domain.id} className="mb-4">
                            <motion.div
                                className="domain-card"
                                initial={{ opacity: 0, y: 40 }}
                                animate={isInView ? { opacity: 1, y: 0 } : {}}
                                transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
                                whileHover={{ y: -6 }}
                            >
                                <div className="domain-card-header">
                                    <div className="domain-icon">
                                        <img src={domain.icon} alt={domain.title} style={{ width: '42px', height: '42px', objectFit: 'contain' }} />
                                    </div>
                                    <h3 className="domain-title">{domain.title}</h3>
                                </div>
                                <ul className="domain-list">
                                    {domain.items.map((item, i) => (
                                        <li key={i}>
                                            <span className="domain-bullet"><i className="bi bi-check2"></i></span>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </motion.div>
                        </Col>
                    ))}
                </Row>

                {/* CTA */}
                <motion.div
                    className="section-cta"
                    initial={{ opacity: 0, y: 30 }}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.8, delay: 0.7 }}
                >
                    <div className="section-cta-inner">
                        <h3>Vous avez un projet en tête ?</h3>
                        <p>Nos experts sont à votre disposition pour discuter de votre projet et vous proposer les meilleures solutions.</p>
                        <div className="section-cta-buttons">
                            <button className="section-cta-btn-outline" onClick={() => navigateTo('team')}>
                                NOTRE ÉQUIPE
                            </button>
                            <button className="section-cta-btn-solid" onClick={() => navigateTo('contact')}>
                                NOUS CONTACTER
                            </button>
                        </div>
                    </div>
                </motion.div>

            </Container>
        </section>
    );
};

export default Projects;
